import {markRequestsAsPrinted} from '../api/catalog'
import {MARK_PRINTED_CATALOG_REQUESTS} from "../mutation-types"

// initial state
const admin = {
    namespace: 'catalog',
    state: {
        all: [],
        status: 'unauthorized',
        last_sync: false,
        details: {
            id: 0,
            first_name: '',
            last_name: '',
            email: '',
            role: 'User',
        }
    },
    getters: {
        catalogRequests: (state, getters) => state.all.filter(order => getters.company.initials === null || order.company === getters.company.initials)
            .sort((a, b) => b.id - a.id),
        newCatalogRequests: (state, getters) => state.all.filter(order => getters.company.initials === null || order.company === getters.company.initials)
            .filter(request => request.printed === false).sort((a, b) => b.id - a.id),
    },
    mutations: {
        [MARK_PRINTED_CATALOG_REQUESTS]: (state, requests) => {
            for (let requestIndex in requests) {
                let requestID          = requests[requestIndex]
                let updateRequest      = state.all.find(request => request.id === requestID)
                let updateRequestIndex = state.all.indexOf(updateRequest)
                let newRequest         = JSON.parse(JSON.stringify(state.all[updateRequestIndex]))
                newRequest.printed     = true

                state.all.splice(updateRequestIndex, 1, newRequest)
            }
        },
    },

    actions: {
        [MARK_PRINTED_CATALOG_REQUESTS]: ({commit, dispatch, state}, requests) => {
            return new Promise((resolve, reject) => {
                markRequestsAsPrinted(commit, {requests})
                    .then(data => {
                        commit(MARK_PRINTED_CATALOG_REQUESTS, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        }
    },
};

export default admin;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/catalog/index.js
// module id = 613
// module chunks = 0